import { render, staticRenderFns } from "./receiptsComponent.vue?vue&type=template&id=d4121066&scoped=true&"
import script from "./receiptsComponent.vue?vue&type=script&lang=js&"
export * from "./receiptsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4121066",
  null
  
)

export default component.exports